import styled from '@emotion/styled'
import { BreakpointWidths } from '@pharmac-extranet/shared'
import { PharmacOmaLogo } from '@pharmac/ui'
import { LocalizedLink } from './LocalizedLink'
import { MegaMenu } from './MegaMenu'
import { NavigationBarLink } from './NavigationBarLink'
import { ShoppingCartButton } from './shopping-cart/ShoppingCartButton'
import { useExtranetLinks } from './useExtranetLinks'
import { UserMenu } from './user-menu/UserMenu'

const NavigationBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  @media (min-width: ${BreakpointWidths.Desktop}px) {
    width: 1200px;
  }

  @media (max-width: ${BreakpointWidths.Desktop - 1}px) {
    width: 100%;
    padding-right: var(--spacing-medium);
  }
`

const TopBarLogoContainer = styled.div`
  height: 100%;
  margin-right: var(--spacing-large);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  a {
    display: block;
    height: 35px;
    text-align: center;
  }

  svg {
    height: 35px;
  }

  padding-left: 0;

  @media (max-width: ${BreakpointWidths.Desktop + 30}px) {
    padding-left: var(--spacing-large);
  }
`

const NavigationLinks = styled.div`
  width: 100%;

  ul {
    width: 100%;
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    height: 100%;

    li {
      a,
      button {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
`

export const DesktopNavigation = () => {
  const links = useExtranetLinks()

  return (
    <>
      <NavigationBarContainer>
        <TopBarLogoContainer>
          <LocalizedLink to="root">
            <PharmacOmaLogo
              width="80px"
              color="white"
            />
          </LocalizedLink>
        </TopBarLogoContainer>
        <NavigationLinks className="nav-links">
          <ul>
            {links &&
              links.map((link, i) => (
                <NavigationBarLink
                  link={link}
                  key={'nvgl' + i}
                />
              ))}
          </ul>
        </NavigationLinks>
        <ShoppingCartButton />
        <UserMenu />
      </NavigationBarContainer>
      <MegaMenu />
    </>
  )
}
